
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.277","height":"21.5","viewBox":"0 0 16.277 21.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M8.087 15.327a.832.832 0 11.832-.832.812.812 0 01-.832.832zM8.087 12.549a.812.812 0 01-.832-.832V7.559a.812.812 0 01.832-.832.812.812 0 01.832.832v4.158c.118.476-.357.832-.832.832z"}}),_c('path',{staticClass:"b",attrs:{"d":"M9.045 19.764V21.8H7.487v-2.036h-2.4V21.8h-1.2l-.24-1.677-2.156-3.474a9.945 9.945 0 01-.12-10.3l1.2-2.036a4.066 4.066 0 00.48-3.113 1.519 1.519 0 01.12-.719c.12-.24.359-.24.6-.24a.9.9 0 01.838.6 6.307 6.307 0 01-.719 4.192l-1.2 2.036a8.274 8.274 0 00.12 8.624l1.8 2.875h6.708l2.276-3.474a7.356 7.356 0 00.12-7.666l-1.437-2.515a6.432 6.432 0 01-.719-4.192c.12-.359.24-.6.6-.719h.12a.854.854 0 01.719.359.9.9 0 01.12.6 4.679 4.679 0 00.479 3.114l1.437 2.515a9.029 9.029 0 01-.12 9.343l-2.515 3.953-.24 1.8h-1.077V19.65H9.045z"}})])
          )
        }
      }
    